import {envUtil} from './env';

export const pixelUtil = {
  init() {
    if (!envUtil.isProduction) {
      return
    }

    ;(function(e,a,c,u,t,n,i) {
      if (e.bxtag) {
        return
      }
      t = e.bxtag = function(){
        t.invokeFunc ? t.invokeFunc.apply(t,arguments) : t.qu.push(arguments)
      };
      if (!e._tecq) {
        e._tecq = t
      }
      t.push = t;
      t.qu = [];
      n = a.createElement(c);
      n.async = !0;
      n.src = u;
      i = a.getElementsByTagName(c)[0];
      i.parentNode.insertBefore(n,i);
    })(window, document, "script", "//pixel.bxtag.com/tag/brainx.min.js");
    window.bxtag('init','X-RFUL37N6K71U');
    window.bxtag('event','page_view',{desc: document.title});
  },
}
